<!--卡片图表-->
<template>
  <div
    class="card-wrap"
    :style="{
      background: config.background,
      'border-radius': config.isRadio ? '5px' : 0,
      fontFamily:config.fontFamily?config.fontFamily:'auto',
    }"
  >
    <div
      class="card-header"
      :style="{
        color: config.title.color,
        height: config.title.height + 'px',
        lineHeight: config.title.lineHeight + 'px',
        fontSize: config.title.fontSize + 'px',
      }"
    >
      {{ config.title.text }}
    </div>
    <div
      :class="[config.content.cardRAlign === 'bottom' ? 'card-box-b' : 'card-box-r']"
      :style="{
        marginTop: config.content.offsetY + 'px',
        textAlign: config.content.position
      }"
    >
      <span
        class="number"
        :style="{
          color: config.content.color,
          fontSize: config.content.fontSize + 'px',
          marginLeft: config.content.offsetX + 'px',
        }"
      >{{ getContentMoney() }}{{ config.content.company }}
      </span>
      <div class="right">
        <ul>
          <li v-if="config.month1.visible">
            <span
              class="label"
              :style="{
                color: config.month1.color,
                fontSize: config.month1.fontSize + 'px',
              }"
            >{{ config.month1.text }}</span>
            <img
              class="img"
              v-if="monthM"
              src="@/assets/images/card-rise.png"
              alt=""
            />
            <img
              class="img"
              v-if="!monthM"
              src="@/assets/images/card-floor.png"
              alt=""
            />
            <span
              class="label"
              :style="{
                color: config.month1.color,
                fontSize: config.month1.fontSize + 'px',
              }"
            >{{ getMonthMatch("x1Field") + "%" }}</span>
          </li>
          <li v-if="config.month2.visible">
            <span
              class="label"
              :style="{
                color: config.month1.color,
                fontSize: config.month1.fontSize + 'px',
              }"
            >{{ config.month2.text }}</span>
            <img
              class="img"
              v-if="monthY"
              src="@/assets/images/card-rise.png"
              alt=""
            />
            <img
              class="img"
              v-if="!monthY"
              src="@/assets/images/card-floor.png"
              alt=""
            />
            <span
              class="label"
              :style="{
                color: config.month1.color,
                fontSize: config.month1.fontSize + 'px',
              }"
            >{{ getMonthMatch("x2Field") + "%" }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="progress">
      <ul>
        <li
          class="progress_item"
          v-if="config.target.visible"
          :style="{
            marginLeft: config.target.offsetX + 'px',
            marginTop: config.target.offsetY + 'px'
          }"
        >
          <span
            :style="{
              color: config.target.color,
              fontSize: config.target.fontSize + 'px'
            }"
          >{{ config.target.text }}</span>
          <span class="text">
            {{ getMonthMatch('yField') }}{{ config.target.company }}
          </span>
        </li>
        <li
          class="progress_item"
          v-if="config.completeR.visible"
          :style="{
            marginLeft: config.completeR.offsetX + 'px',
            marginTop: config.completeR.offsetY + 'px'
          }"
        >
          <span
            :style="{
              color: config.completeR.color,
              fontSize: config.completeR.fontSize + 'px',
            }"
          >{{ config.completeR.text }}</span>
          <Progress
            height="14px"
            class="progressVal"
            :config="config"
            :num="getMonthMatch('y1Field')"
          ></Progress>
        </li>
        <li
          class="progress_item"
          v-if="config.matchingR.visible"
          :style="{
            marginLeft: config.matchingR.offsetX + 'px',
            marginTop: config.matchingR.offsetY + 'px'
          }"
        >
          <span
            :style="{
              color: config.matchingR.color,
              fontSize: config.matchingR.fontSize + 'px',
            }"
          >{{ config.matchingR.text }}</span>
          <Progress
            height="14px"
            class="progressVal"
            :config="config"
            :num="getMonthMatch('y2Field')"
          ></Progress>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Progress from '../Progress'
export default {
  name: 'Card2',
  props: {
    config: {
      type: [Object, Array],
      default: () => {
        return {}
      }
    },
    chartData: {
      type: Array,
      default () {
        return []
      }
    }
  },
  computed: {
    monthM () {
      return this.getMonthMatch('x1Field') >= 0
    },
    monthY () {
      return this.getMonthMatch('x2Field') >= 0
    }
  },
  data () {
    return {
      cardData: this.chartData[0]
    }
  },
  methods: {
    getMonthMatch (key) {
      return this.chartData[0][this.config[key]]
    },
    getContentMoney () {
      let str = this.chartData[0]?.[this.config['xField']] ?? ''
      if (this.config.content['thousandthPercent']) {
        if (str.toString().split('.')[1]) {
          str =
            this.format_number(str.toString().split('.')[0]) +
            '.' +
            str.toString().split('.')[1]
        } else {
          str = this.format_number(str.toString().split('.')[0])
        }
      }
      return str
    },
    format_number (n) {
      n = n.toString()
      var len = n.length
      if (len <= 3) {
        return n
      }
      var r = len % 3
      const start = n.slice(0, r)
      const end = n.slice(r).match(/\d{3}/g).join(',')
      return r > 0 ? start + ',' + end : end
    }
  },
  components: {
    Progress
  },
  watch: {
    chartData: {
      handler (val) {
        this.cardData = val[0]
      },
      deep: true
    }
  }
}
</script>

<style lang="stylus" scoped>
.card-wrap
  width 100%
  height 100%
  border-radius 5px
  background #0075ff
  box-sizing border-box
  font-size 18px
  .card-header
    height 24px
    line-height 24px
    padding 0 0 10px 0
    color #FFFFFF
  .card-box-r, .card-box-b
    padding-bottom 15px
    color #FFFFFF
    display flex
    .number
      flex 1
    .company
      color #ffffffcc
    .right
      font-size 12px
      color #ffffffcc
      margin auto 0
      .img
        margin 0 5px
        vertical-align middle
  .card-box-b
    display block
    &::before
      display block
      content ''
      clear both
    .right
      ul
        display flex
        li
          flex 1
  .progress_item
    display flex
    align-items center
    margin-bottom 5px
    color #ffffffcc
    &:nth-last-child(1)
      margin-bottom 0
    .progressVal
      flex: 1
      margin-left 5px
    .img
      margin 0 5px
    >>>.el-progress
      flex 1
      margin-left 5px
    .text
      font-size 14px
      margin-left 5px
    >>>.el-progress-bar__innerText
      margin -2px 5px 0 5px
</style>
